
import { getCleanedJobTitle } from '@twago/configs'
import { EFilter, EProjectType, ESearchPageType } from '@/helpers/enums'
import { searchProjects } from '@/helpers/search'

const TOTAL_VISIBLE_RESULTS = 8

export default {
  name: 'CityInPool',
  layout: 'portal',
  auth: false,
  middleware: ['public-search-disabled', 'search-redirect'],

  async asyncData({ app, route, store, params, redirect, error }) {
    const allPools = await store.state.publicSearch.allPools
    const checkId = allPools.filter((item) => item.id === Number(params.id))
    const checkCity = allPools.map((item) => {
      return item.poolCities.filter((inner) => getCleanedJobTitle(inner).includes(params.city))
    })

    if (!checkId.length) {
      return redirect(app.$link.projectSearch())
    }

    if (!app.$flatten(checkCity).length) {
      return redirect(app.$link.pool({ id: params.id, title: app.$t(params.poolName) }))
    }

    try {
      const parseCityName = checkCity.find((item) => item.length)
      const { currentOffset, results, total } = await searchProjects({
        pageSize: TOTAL_VISIBLE_RESULTS,
        context: app,
        type: EProjectType.PUBLIC,
        typedQuery: ESearchPageType.POOL_IN_CITY,
        route
      })

      if (currentOffset && currentOffset >= total) {
        app.$resetPage(route.query)
      }

      store.commit('SEO_INDEX', total !== 0)

      return {
        pageName: {
          pool: checkId[0].poolNameVerbiage,
          city: parseCityName[0]
        },
        pageDescription: checkId[0].poolDescriptionVerbiage,
        listResults: results,
        listResultsTotal: total,
        currentOffset
      }
    } catch (err) {
      error({
        statusCode: err.response?.status,
        message: err.response?.statusText
      })
    }
  },

  head() {
    const client = this.$store.state.clientContext.name
    return this.$headMetaTags({
      title: this.$t('talent.global.search.city.pool.meta.title', {
        pool: this.$t(this.pageName.pool),
        city: this.$capitalize(this.$route.params.city),
        client: this.$capitalize(client)
      }),
      keywords: this.$t('talent.global.search.city.pool.meta.keywords', {
        pool: this.$t(this.pageName.pool),
        city: this.$capitalize(this.$route.params.city),
        client: this.$capitalize(client)
      }),
      description: this.$t('talent.global.search.city.pool.meta.description', {
        pool: this.$t(this.pageName.pool),
        city: this.$capitalize(this.$route.params.city),
        client: this.$capitalize(client)
      })
    })
  },

  computed: {
    bannerTitle() {
      return this.$t('talent.global.search.pools.in.city.title', {
        pool: this.$t(this.pageName.pool),
        city: this.pageName.city
      })
    },

    totalVisible() {
      return TOTAL_VISIBLE_RESULTS
    }
  },

  watchQuery: [EFilter.PAGE]
}
